import { Route } from '@angular/router';
import {
  AUTH_LOGIN,
  AUTH_LOGIN_OTP,
  AUTH_RESET_PASSWORD,
  AUTH_VERIFY_OTP,
  AUTH_VERIFY_USER,
  PageTitles
} from '@smarsh-cyber/shared/constants';

export const AUTH_ROUTING: Route[] = [
  {
    path: '',
    redirectTo: AUTH_LOGIN,
    pathMatch: 'prefix'
  },
  {
    path: AUTH_LOGIN,
    loadComponent: () =>
      import('./pages/login/login.component').then((c) => c.LoginComponent),
    title: PageTitles.LOGIN
  },
  {
    path: AUTH_VERIFY_USER,
    loadComponent: () =>
      import('./pages/verify-user/verify-user.component').then(
        (c) => c.VerifyUserComponent
      ),
    title: PageTitles.VERIFY_USER
  },
  {
    path: AUTH_VERIFY_OTP,
    loadComponent: () =>
      import('./pages/verify-otp/verify-otp.component').then(
        (c) => c.VerifyOtpComponent
      ),
    title: PageTitles.VERIFY_OTP
  },
  {
    path: AUTH_RESET_PASSWORD,
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then(
        (c) => c.ResetPasswordComponent
      ),
    title: PageTitles.RESET_PASSWORD
  },
  {
    path: AUTH_LOGIN_OTP,
    loadComponent: () =>
      import('./pages/otp-login/otp-login.component').then(
        (c) => c.OtpLoginComponent
      ),
    title: PageTitles.OTP_LOGIN
  }
];
